import API_CONFIG from './apiConfig.js';

const CLIENT_ID = '5e6030d0-08bd-418b-a12e-e7377db0ea6d'   //716383eb-7d09-4068-9ebf-3d4ce43dd948, 5e6030d0-08bd-418b-a12e-e7377db0ea6d       // Primary app registration (SPA + API for single-app setup)
const AUTHORITY_HOST = 'login.microsoftonline.com';
const EXTERNAL_AUTHORITY_PATH = 'common';

// Centralized client-side tenant allowlist for external deployments.
// Empty array means allow all tenants on the client gate.
export const allowedTenantIds = [
    'ba7cfdf3-def9-464a-9fd2-1d7236bf7edd',
    'd4954c54-7b6b-4277-af60-e533bafcd02c',
    'd4da2aa5-e607-4917-bfab-d45c62b88ff5',
    'f7e124e1-3cbb-4714-b90e-d08652874b65',
    'aca0439e-7342-4da4-b3e0-1a3e6c5498fb',
    '2fa1a9ba-2524-4ea5-9a52-dca11a351b78',
    '9188040d-6c67-4c5b-b112-36a304b66dad'
].map((value) => value.toLowerCase());
// MAKE SURE TO SET THE ENV VAR IN THE SERVER

const msalClientId = process.env.REACT_APP_AZURE_CLIENT_ID || CLIENT_ID;
// Optional override for two-app setups (separate API app registration).
// If not set, use the same app registration as the SPA.
const apiAudienceClientId =
    process.env.REACT_APP_API_CLIENT_ID ||
    process.env.REACT_APP_API_AUDIENCE_CLIENT_ID ||
    msalClientId;
const externalAuthority = `https://${AUTHORITY_HOST}/${EXTERNAL_AUTHORITY_PATH}`;
const internalAuthority = `https://${AUTHORITY_HOST}/ba7cfdf3-def9-464a-9fd2-1d7236bf7edd`;
const msalAuthority = API_CONFIG.DEPLOYMENT_AUDIENCE === 'internal'
    ? internalAuthority
    : externalAuthority;
const msalKnownAuthorities = [AUTHORITY_HOST];
const runtimeRedirectUri = typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : API_CONFIG.FRONTEND_URL;

export const msalConfig = {
    auth: {
        clientId: msalClientId,
        authority: msalAuthority,
        knownAuthorities: msalKnownAuthorities,
        redirectUri: runtimeRedirectUri,
        postLogoutRedirectUri: runtimeRedirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case 0: // Error
                        console.error(message);
                        return;
                    case 1: // Warning
                        console.warn(message);
                        return;
                    case 2: // Info (This puts out a lot of info, comment out if getting spam)
                        //console.info(message);
                        return;
                    case 3: // Verbose
                        //console.debug(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const loginRequest = {
    scopes: ["openid", "profile", "email"],
    authority: msalAuthority,
    prompt: 'select_account',
};

const resolveApiScopes = () => {
    const configuredScopes = process.env.REACT_APP_API_SCOPES;
    if (configuredScopes) {
        const scopes = configuredScopes
            .split(',')
            .map(v => v.trim())
            .filter(Boolean);
        if (scopes.length > 0) {
            return scopes;
        }
    }

    const configuredScope = process.env.REACT_APP_API_SCOPE;
    if (configuredScope && configuredScope.trim()) {
        return [configuredScope.trim()];
    }

    // Fallback to API audience scope. In single-app setups this matches the SPA app id.
    return [`${apiAudienceClientId}/.default`];
};

// For API calls, scopes can be configured with REACT_APP_API_SCOPE(S).
export const apiRequest = {
    scopes: resolveApiScopes(),
};
